import { Section } from "../../utils/Entities";
import NavBarTabNameAndStatus from "../../shared/NavBarTabNameAndStatus";
import IntegrationBuilderLeftNavBarSubTab from "./IntegrationBuilderLeftNavSubTab";
import { NavigationBarButton } from "@merge-api/merge-javascript-shared";

interface Props {
  item: Section;
  itemIndex: number;
  relativePathOfSelectedPage: string;
  onNavigate: (path: string) => void;
}

const IntegrationBuilderLeftNavBarTab = ({
  item,
  itemIndex,
  relativePathOfSelectedPage,
  onNavigate,
}: Props) => {
  // See if we are on active tab or sub-tab
  const relativePathIdentifiers = item.subSections?.map((subItem) => subItem.sectionIdentifier) || [
    item.sectionIdentifier,
  ];
  const isContainsRelativePath = relativePathIdentifiers.includes(relativePathOfSelectedPage);

  const SUBTAB_HEIGHT = 32; // px, adjust as needed
  const SUBTAB_SPACING = 12; // px, from Tailwind space-y-3
  const CONTAINER_PADDING = 16; // px, from Tailwind py-2 (8px top + 8px bottom)

  const subTabCount = item.subSections?.length || 0;
  const accordionHeight =
    subTabCount > 0
      ? subTabCount * SUBTAB_HEIGHT + (subTabCount - 1) * SUBTAB_SPACING + CONTAINER_PADDING
      : 0;

  const displaySubNav = !item.disabled && !!item.subSections && isContainsRelativePath;
  const containerHeight = displaySubNav ? `${accordionHeight}px` : "0px";
  const containerOpacity = displaySubNav ? 1 : 0;

  return (
    <div>
      <NavigationBarButton
        key={itemIndex}
        onClick={() => onNavigate(item.path)}
        selected={isContainsRelativePath}
        disabled={item.disabled}
      >
        <NavBarTabNameAndStatus name={item.name} icon={item.icon} state={item.state} />
      </NavigationBarButton>
      <div
        className="transition-all duration-300 ease-in-out overflow-hidden"
        style={{ height: containerHeight, opacity: containerOpacity }}
      >
        {displaySubNav && (
          <div className="border-l-2 ml-5 mt-3 border-gray-10 space-y-3 py-2">
            {item.subSections?.map((subItem, subItemIndex) => {
              const isMatchingPath = subItem.sectionIdentifier === relativePathOfSelectedPage;
              return (
                <IntegrationBuilderLeftNavBarSubTab
                  key={subItemIndex}
                  subItem={subItem}
                  onNavigate={onNavigate}
                  isMatchingPath={isMatchingPath}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default IntegrationBuilderLeftNavBarTab;
